import { Form, Button } from "react-bootstrap";
import { MdSearch } from "react-icons/md";
import styled from "styled-components";

export const SelectFilter = styled(Form.Select)`
  border: 1.5px solid #e1e6ef;
  border-radius: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.3px;
  color: #1e212a;
  width: 142px;
  height: 44px;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 10px;
    margin-right: 10px;
  }
`;

export const FormFilter = styled.div`
  display: flex;
  margin-top: 10px;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const OptionFilter = styled.option``;

export const BoxSearch = styled.div`
  display: flex;
  align-items: center;
  width: 340px;
  height: 44px;
  background: #f3f5fb;
  border: 1.5px solid #e1e6ef;
  padding-left: 10px;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 10px;
    margin-right: 10px;
  }
`;

export const BoxSearchFilter = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  background: #f3f5fb;
  border: 1.5px solid #e1e6ef;
  padding-left: 10px;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 10px;
    margin-right: 10px;
  }
`;

export const IconSearch = styled(MdSearch)`
  color: #1e212a;
`;

export const InputSearch = styled.input`
  border: none;
  background: none;
  outline: none !important;
`;

export const UntilText = styled.span`
  font-size: 14px;
  color: #6b7280;
  padding: 10px;
`;

export const InputDateInicial = styled.input`
  border: none;
  height: 44px;
  width: 170px;
  background: none;
  outline: none !important;
  align-items: center;
  padding: 5px;
`;

export const InputDateFinal = styled.input`
  border: none;
  height: 44px;
  width: 170px;
  background: none;
  outline: none !important;
  align-items: center;
  padding: 5px;
`;

export const ButtonSearch = styled(Button)`
  border-radius: 0 4px 4px 0;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 10px;
    margin-right: 10px;
  }
`;

export const ButtonClearSearch = styled(Button)`
  border-radius: 0 4px 4px 0;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 10px;
    margin-right: 10px;
  }
`;
